/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowTriggerEventCreateDto } from '../../models/workflow-trigger-event-create-dto';
import { WorkflowTriggerEventDto } from '../../models/workflow-trigger-event-dto';

export interface AutomatedProcessCreateTriggerEvent$Params {
      body: WorkflowTriggerEventCreateDto
}

export function automatedProcessCreateTriggerEvent(http: HttpClient, rootUrl: string, params: AutomatedProcessCreateTriggerEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventDto>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessCreateTriggerEvent.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkflowTriggerEventDto>;
    })
  );
}

automatedProcessCreateTriggerEvent.PATH = '/automated-process/workflow-trigger/trigger-event';